import { render } from "./PdfViewerComp.vue?vue&type=template&id=371d0700&scoped=true"
import script from "./PdfViewerComp.vue?vue&type=script&lang=js"
export * from "./PdfViewerComp.vue?vue&type=script&lang=js"

import "./PdfViewerComp.vue?vue&type=style&index=0&id=371d0700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371d0700"]])

export default __exports__